import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { GoEye, GoEyeClosed } from "react-icons/go";
import "../../_css/Register.css";
import {
  isValidEmail,
  isValidPassword,
  isValidPhoneNumber,
  notifyError,
  notifySuccess,
  saveAuthToken,
} from "../../utils/helper";
import { getAllSchools, googleLogin, registerUser } from "../../requests";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import SearchableDropdown from "../common/SearchableDropdown";
import { GoogleLogin,useGoogleLogin } from "@react-oauth/google";
import { provinces, schoolTypes ,grades, schoolPositions, subjects} from "../constants";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    school: "",
    province: "",
    schoolType: "",
    grade: "",
    position: "",
    subject: "",
    phone_number: "",
  });

  const [step, setStep] = useState(1);
  const [enteredOtp, setEnteredOtp] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [schools, setSchools] = useState([]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getSchools = async () => {
    try {
      const schoolRes = await getAllSchools();
      const uniqueSchools = schoolRes?.data?.schools.filter(
        (e) => e != "Other"
      ); // Filter out 'Other' school
      setSchools(uniqueSchools);
    } catch (error) {
      // notifyError("Error fetching schools");
    }
  };
  const getOtp = async (e) => {
    e.preventDefault();

    if (isNotificationVisible) return;

    notify_visibility(2000);

    if (!acceptedTerms) {
      notifyError("Please accept the Terms and Conditions to continue");
      return;
    }

    if (!email) {
      notifyError("Please enter an email address");
      return;
    }

    if (!password) {
      notifyError("Please enter a password");
      return;
    }

    if (!isValidEmail(email)) {
      notifyError("Please enter a valid email address");
      return;
    }

    if (!isValidPassword(password)) {
      notifyError("Please enter a strong password");
      return;
    }

    dispatch(startLoader());

    try {
      const res = await registerUser({ email, password });

      if (res.status < 400) {
        setStep(2);
      }
    } catch (error) {
      notifyError(
        error?.response?.data?.error ||
          "Server is busy. Please try again after sometime..."
      );
    } finally {
      dispatch(stopLoader());
    }
  };

  const verifyOTP = async (e) => {
    e.preventDefault();

    if (isNotificationVisible) return;

    notify_visibility(2000);

    if (!email) {
      notifyError("Please enter an email address");
      return;
    }

    if (!password) {
      notifyError("Please enter a password");
      return;
    }

    if (!isValidEmail(email)) {
      notifyError("Please enter a valid email address");
      return;
    }

    if (!isValidPassword(password)) {
      notifyError("Please enter a strong password");
      return;
    }

    if (!enteredOtp) {
      notifyError("Please enter a OTP");
      return;
    }

    if (enteredOtp.length < 6) {
      notifyError("Please enter a OTP of 6 digits");
      return;
    }

    dispatch(startLoader());

    try {
      const res = await registerUser({
        email,
        password,
        otp: enteredOtp.trim(),
      });
      if (res.status < 400) {
        // console.log(res.data);
        notifySuccess("OTP verified successfully");
        setStep(3);
      }
    } catch (error) {
      notifyError(
        error?.response?.data?.error || "Invalid code. Please try again."
      );
    } finally {
      dispatch(stopLoader());
    }
  };

  const validatePrimary = (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    setStep(4);
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    dispatch(startLoader());

    try {
      const res = await registerUser({
        ...formData,
        school_level: formData.schoolType,
        email,
        password,
        otp: enteredOtp,
      });

      if (res.status < 400) {
        notifySuccess("Teacher registered successfully");
        setEmail("");
        setEnteredOtp("");
        setPassword("");
        setFormData({
          name: "",
          school: "",
          province: "",
          schoolType: "",
          grade: "",
          position: "",
          subject: "",
          phone_number: "",
        });
        navigate("/login");
      }
    } catch (error) {
      notifyError(
        error?.response?.data?.error ||
          "Error registering a teacher. Please try again after some time."
      );
    } finally {
      dispatch(stopLoader());
    }
  };

  const notify_visibility = (timer) => {
    if (isNotificationVisible) return;

    setIsNotificationVisible(true);

    setTimeout(() => {
      setIsNotificationVisible(false);
    }, timer);
  };

  const validate = () => {
    if (isNotificationVisible) return;

    notify_visibility(2000);

    if (!email) {
      notifyError("Please enter an email address");
      return false;
    }

    if (!isValidEmail(email)) {
      notifyError("Please enter a valid email address");
      return false;
    }

    if (!password) {
      notifyError("Please enter a password");
      return false;
    }

    if (!isValidPassword(password)) {
      notifyError("Please enter a strong password");
      return false;
    }

    if (!formData.name) {
      notifyError("Please enter a name");
      return false;
    }

    const nameRegex = /^[A-Za-z ]{1,30}$/;

    if (!nameRegex.test(formData.name)) {
      notifyError("Please enter a name that contains only letters");
      return false;
    }

    if (!formData.phone_number) {
      notifyError("Please enter a phone number");
      return false;
    }
    if (!isValidPhoneNumber(formData.phone_number)) {
      notifyError("Please enter a phone number of 10 digits");
      return false;
    }

    if (!formData.school) {
      notifyError("Please enter a school");
      return false;
    }

    if (!formData.province) {
      notifyError("Please select a province");
      return false;
    }

    return true;
  };

 
 


  

  let loginAudio;
  

  const loginwithGoogle = async (res) => {
    if (!acceptedTerms) {
      notifyError("Please accept the Terms and Conditions to continue");
      return;
    }

    // prepare audio during user gesture
    loginAudio = new Audio("/loginSound.wav");
    loginAudio.load();

      dispatch(startLoader());

    try {
      const response = await googleLogin({ credential: res.credential });

      if (response.status < 400) {
        // Now actually play because file is unlocked
        notifySuccess(response?.data?.message || "Logged in successfully");
        saveAuthToken(JSON.stringify(response?.data?.token));

        const user = await response?.data?.user;
        localStorage.setItem("ACCOUNT_STATUS", user?.status);

        loginAudio.play();
        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (user.status == 7) {
          window.location.href = "/teacher-management";
        } else {
          window.location.href = "/";
        }
      }
    } catch (error) {
      console.log(error);
      notifyError(
        error.response?.data?.error ||
          "Something went wrong. Please try again after some time"
      );
    }
    finally {
      dispatch(stopLoader());
    }
  };



  useEffect(() => {
    getSchools();
  }, []);

  return (
    <div className="center-div bg-main">
      {step == 1 && (
        <div className="register-container">
          <div className="register-heading">
            <div className="register-heading-text">Create your account</div>
          </div>

          <div className="register-form">
            <div className="register-form-form">
              <div className="register-input-area">
                <label className="register-form-label">Email</label>
                <input
                  className="register-form-input"
                  type="email"
                  placeholder="example@domain.com"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div
                className="register-input-area"
                style={{ position: "relative" }}
              >
                <label className="register-form-label">Password</label>
                <input
                  className="register-form-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6B7280",
                  }}
                >
                  {" "}
                  {showPassword ? <GoEye /> : <GoEyeClosed />}
                </span>
              </div>
            </div>

            <div className="register-form-submit">
              <button
                className="register-form-button"
                style={{ backgroundColor: "#01A7DE" }}
                onClick={getOtp}
              >
                Continue to SWISH AI
              </button>

              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                marginBottom: "16px",
                fontSize: "14px",
                color: "#6B7280"
              }}>
                <input
                  type="checkbox"
                  id="terms-checkbox"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                  style={{ 
                    marginRight: "8px",
                    cursor: "pointer"
                  }}
                />
                <label 
                  htmlFor="terms-checkbox"
                  style={{ 
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  I agree to the{" "}
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/terms-and-conditions");
                    }}
                    style={{
                      color: "#01A7DE",
                      textDecoration: "underline",
                      cursor: "pointer",
                      marginLeft: "4px"
                    }}
                  >
                    Terms and Conditions
                  </span>
                </label>
              </div>

              <GoogleLogin
              buttonText="Sign up with Google"
              onSuccess={(res) => loginwithGoogle(res)}
              onError={() => {
                console.log("Login Failed");
              }}
            />

              <div className="register-signup-button">
                <p className="register-signup-text">Already have an account?</p>
                <span
                  onClick={() => navigate("/login")}
                  className="register-signup-span"
                >
                  Sign in
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {step == 2 && (
        <div className="register-2fa-container">
          <div className="register-2fa-heading" style={{ width: "367px" }}>
            <div className="register-2fa-heading-text">
              Two-Factor Authentication
            </div>
            <div className="register-2fa-heading-subtext">
              We've sent a 6-digit verification code to your registered email
              address. Please enter the code below to continue.
            </div>
          </div>
          <div className="register-2fa-form" style={{ width: "367px" }}>
            <div className="register-2fa-form-form" style={{ width: "367px" }}>
              <div className="register-input-area" style={{ width: "367px" }}>
                <label className="register-form-label">Enter Code</label>
                <input
                  className="register-form-input no-spinner"
                  style={{ width: "367px" }}
                  type="number"
                  placeholder="Code"
                  name="otp"
                  onInput={(e) => {
                    if (e.target.value.length > 6) {
                      e.target.value = e.target.value.slice(0, 6);
                    }
                  }}
                  value={enteredOtp}
                  onChange={(e) => setEnteredOtp(e.target.value)}
                  required
                />
              </div>
            </div>
            <div
              className="register-2fa-form-submit"
              style={{ width: "367px" }}
            >
              <button
                className="register-form-button"
                style={{ backgroundColor: "#0DB9EA", width: "367px" }}
                onClick={verifyOTP}
              >
                Verify and Continue
              </button>

              <div className="register-signup-button">
                <span
                  className="register-signup-span"
                  style={{ textDecoration: "none" }}
                  onClick={getOtp}
                >
                  Resend Code
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {step == 3 && (
        <div className="register-primary-container">
          <div className="register-primary-heading-con">
            <div className="register-primary-step">Step 1/2</div>
            <div className="register-primary-heading">
              <div
                className="register-2fa-heading-text"
                style={{ textAlign: "left" }}
              >
                Welcome to SWISH AI
              </div>
              <div
                className="register-2fa-heading-subtext"
                style={{ textAlign: "left" }}
              >
                Fill some info to start
              </div>
            </div>
          </div>

          <div className="register-primary-form">
            <div
              className="register-primary-form-form"
              style={{ width: "367px" }}
            >
              <div className="register-input-area" style={{ width: "367px" }}>
                <label className="register-form-label">Enter Full Name</label>
                <input
                  className="register-form-input"
                  style={{ width: "367px" }}
                  type="text"
                  placeholder="Full Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  maxLength="30"
                  required
                />
              </div>

              <div className="register-input-area" style={{ width: "367px" }}>
                <label className="register-form-label">
                  Enter Phone Number
                </label>
                <input
                  className="register-form-input no-spinner"
                  style={{ width: "367px" }}
                  type="number"
                  placeholder="Phone"
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleChange}
                  onInput={(e) => {
                    if (e.target.value.length > 10) {
                      e.target.value = e.target.value.slice(0, 10);
                    }
                  }}
                  required
                />
              </div>

              <div
                className="register-input-area"
                style={{ width: "367px" }}
                type="text"
              >
                <label className="register-form-label">School Name</label>
                <SearchableDropdown
                  options={[...schools]}
                  selected={formData.school}
                  setSelected={(e) => setFormData((p) => ({ ...p, school: e }))}
                />

                {/* <option value="" disabled hidden></option>
                  {schools.map((e, i) => (
                    <option key={i} value={e}>
                      {e}
                    </option>
                  ))} */}
                {/* </select> */}
              </div>

              <div
                className="register-input-area"
                style={{ width: "367px" }}
                type="text"
              >
                <label className="register-form-label">Province</label>
                <SearchableDropdown
                  options={[...provinces]}
                  selected={formData.province}
                  setSelected={(e) =>
                    setFormData((p) => ({ ...p, province: e }))
                  }
                />
              </div>
            </div>

            <div
              className="register-primary-form-submit"
              style={{ width: "367px" }}
              type="text"
            >
              <button
                className="register-form-button"
                style={{ width: "367px" }}
                type="text"
                onClick={validatePrimary}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {step == 4 && (
        <div className="register-secondary-container">
          <div className="register-primary-heading-con">
            <div className="register-primary-step">Step 2/2</div>
            <div className="register-primary-heading">
              <div
                className="register-2fa-heading-text"
                style={{ textAlign: "left" }}
              >
                Welcome {formData?.name || "To SWISH AI"}
              </div>
              <div
                className="register-2fa-heading-subtext"
                style={{ textAlign: "left" }}
              >
                Fill some additional info to start
              </div>
            </div>
          </div>

          <div className="register-primary-form" style={{ height: "372px" }}>
            <div
              className="register-primary-form-form"
              style={{ height: "300px", width: "367px" }}
            >
              <div
                className="register-input-area"
                style={{ width: "367px" }}
                type="text"
              >
                <label className="register-form-label">School type</label>
                <SearchableDropdown
                  options={[...schoolTypes]}
                  selected={formData.schoolType}
                  setSelected={(e) =>
                    setFormData((p) => ({ ...p, schoolType: e }))
                  }
                />
              </div>

              <div
                className="register-input-area"
                style={{ width: "367px" }}
                type="text"
              >
                <label className="register-form-label">Grade</label>
                <SearchableDropdown
                  options={[...grades]}
                  selected={formData.grade}
                  setSelected={(e) => setFormData((p) => ({ ...p, grade: e }))}
                  type="number"
                  allowManualEntry={false}
                />
              </div>
              <div
                className="register-input-area"
                style={{ width: "367px" }}
                type="text"
              >
                <label className="register-form-label">Position</label>
                <SearchableDropdown
                  options={[...schoolPositions]}
                  selected={formData.position}
                  setSelected={(e) =>
                    setFormData((p) => ({ ...p, position: e }))
                  }
                />
              </div>
              <div
                className="register-input-area"
                style={{ width: "367px" }}
                type="text"
              >
                <label className="register-form-label">Subject</label>
                <SearchableDropdown
                  options={[...subjects]}
                  selected={formData.subject}
                  setSelected={(e) =>
                    setFormData((p) => ({ ...p, subject: e }))
                  }
                />
              </div>
            </div>

            <div
              className="register-primary-form-submit"
              style={{ width: "367px" }}
              type="text"
            >
              <button
                className="register-form-button"
                style={{ width: "367px" }}
                type="text"
                onClick={handleRegister}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;
